import React, { FC, useState } from "react";
import SkeletonItem from "../../../../SkeletonItem/SkeletonItem";
import "./NftActionsTab.scss";
const NftActionsTab: FC<{
  tabTitle: string;
  tabAmount: number;
  isActive: boolean;
  isLoadingNfts: boolean;
  tooltipTitle: string;
  onClick: () => void;
}> = ({
  tabAmount,
  tabTitle,
  isActive,
  isLoadingNfts,
  tooltipTitle,
  onClick,
}) => {
  const [isTooltipVisible, toggleIsTooltipVisible] = useState(false);
  return (
    <>
      {!isLoadingNfts ? (
        <div className="nft-actions-tab__wrapper">
          {isTooltipVisible && (
            <div className="nft-actions-tab__tooltip">
              <p>{tooltipTitle}</p>
            </div>
          )}
          <button
            onMouseEnter={() => toggleIsTooltipVisible(true)}
            onMouseLeave={() => toggleIsTooltipVisible(false)}
            onClick={onClick}
            className={`${
              isActive
                ? "nft-actions-tab nft-actions-tab--active"
                : "nft-actions-tab"
            }`}
          >
            {tabTitle}({tabAmount})
          </button>
        </div>
      ) : (
        <SkeletonItem height={27} width={66} borderRadius={8} />
      )}
    </>
  );
};

export default NftActionsTab;
